// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2BnW6","empty":"ModalGraph_empty__3oi4X"};